import { Workflow, PhoneIncoming, MessageCircle } from 'lucide-react'
import { FlowTypes } from 'v2/types'
import { type NodeDataBase, FlowNodeTypes, StartNodeTypes } from 'v2/pages/flow/types'
import type { Node } from '@xyflow/react'

export const startNodeTitle: Partial<Record<FlowTypes, { title: string; icon: JSX.Element }>> = {
  [FlowTypes.api_request]: {
    title: 'Trigger an API Request',
    icon: <Workflow size={16} />,
  },
  [FlowTypes.incoming_call]: {
    title: 'When a customer calls',
    icon: <PhoneIncoming size={16} />,
  },
  [FlowTypes.incoming_chat]: {
    title: 'When a customer sends a message on Chat',
    icon: <MessageCircle size={16} />,
  },
}

export const sidebarTitle = (
  flowType: FlowTypes,
  selectedNode: Node<NodeDataBase<unknown>> | undefined,
) => {
  if (selectedNode?.type !== FlowNodeTypes.start)
    return { title: selectedNode?.data.config.name ?? '', icon: null }
  return {
    title: startNodeTitle[flowType]?.title,
    icon: startNodeTitle[flowType]?.icon,
  }
}

function isStartNodeType(val: unknown): val is StartNodeTypes {
  return Object.values(StartNodeTypes).includes(val as StartNodeTypes)
}

export const showSidebar = (flowType: FlowTypes, selectedNodeType: FlowNodeTypes) =>
  (selectedNodeType && selectedNodeType !== FlowNodeTypes.start) || isStartNodeType(flowType)
